import { render, staticRenderFns } from "./TaskEntity.vue?vue&type=template&id=6d21c8fc&scoped=true&"
import script from "./TaskEntity.vue?vue&type=script&lang=js&"
export * from "./TaskEntity.vue?vue&type=script&lang=js&"
import style0 from "./TaskEntity.vue?vue&type=style&index=0&id=6d21c8fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d21c8fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d21c8fc')) {
      api.createRecord('6d21c8fc', component.options)
    } else {
      api.reload('6d21c8fc', component.options)
    }
    module.hot.accept("./TaskEntity.vue?vue&type=template&id=6d21c8fc&scoped=true&", function () {
      api.rerender('6d21c8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TaskEntity.vue"
export default component.exports